import type { ChannelHeader } from './ChannelHeader';
import { BDF_ID_FULL_TEXT } from './const';
import SignalFileHeader from './SignalFileHeader';
import type { FileHeader } from './types';

export class SignalFile {
  readonly header: FileHeader;
  signalRecords: number[][] = [];
  readonly totalSecond: number;
  readonly samplingRate: number;
  readonly scaleFactor: number;
  readonly endDate: Date;
  readonly channelHeaders: ChannelHeader[];

  constructor(signalFileHeader: SignalFileHeader) {
    this.header = signalFileHeader.fileHeader;
    this.channelHeaders = signalFileHeader.channelHeaders;
    this.samplingRate = signalFileHeader.samplingRate;
    this.scaleFactor = signalFileHeader.scaleFactor;
    this.totalSecond = signalFileHeader.totalDurationMs / 1000;
    this.endDate = signalFileHeader.endDate;
  }

  setSignalRecords(signalRecords: number[][]) {
    this.signalRecords = signalRecords;
  }

  isBdf() {
    return this.header.id === BDF_ID_FULL_TEXT;
  }
}
